
import { ProfileDetails } from "../features/profile/ProfileDetails";

export function Profile() {
    return (
        <div className="py-2 mt-2 w-full lg:w-[60%] lg:mr-2 lg:m-4">
            <ProfileDetails/>
        </div>
    )
}

